import { TypographyH2 } from '~/core/ui/Heading'
import LPContainer from './LPContainer'
import { useTranslation } from 'react-i18next'
import { TypographyText } from '~/core/ui/Text'

const OurStorySection = () => {
  const { t } = useTranslation()

  return (
    <LPContainer className="desktop:my-[140px] my-[64px]">
      <TypographyH2 className="leading-[52px] font-medium text-gray-900 text-[43px] tablet:text-[61px] tablet:leading-[61px] animate-fadeInUp">
        {t('aboutUs:our_story_title')}
      </TypographyH2>
      <div className="tablet:pl-[270px] mt-9 flex flex-col tablet:flex-row space-y-10 tablet:space-y-0">
        <div className="flex-1">
          <p
            className="text-base text-gray-700 font-normal"
            dangerouslySetInnerHTML={{
              __html: t('aboutUs:our_story_description')
            }}
          />
        </div>
        <div className="tablet:pl-[80px] flex-1 space-y-8">
          <div>
            <TypographyText className="text-[23px] text-gray-700 font-medium">
              {t('aboutUs:our_vision_title')}
            </TypographyText>
            <TypographyText className="text-base text-gray-700 font-normal">
              {t('aboutUs:our_vision_description')}
            </TypographyText>
          </div>
          <div>
            <TypographyText className="text-[23px] text-gray-700 font-medium">
              {t('aboutUs:our_mission_title')}
            </TypographyText>
            <TypographyText className="text-base text-gray-700 font-normal">
              {t('aboutUs:our_mission_description')}
            </TypographyText>
          </div>
        </div>
      </div>
    </LPContainer>
  )
}

export default OurStorySection
